// Нет прав на отчёты iiko у учётной записи сервера: спокойная карточка вместо красной ошибки —
// это настройка прав, а не сбой; исправить может только руководство заведения
import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { CARD_SURFACE_SX, MUTED_TEXT_COLOR } from '../styles/tokens';

export default function NoReportAccess({ sx }) {
  return (
    <Box
      role="status"
      sx={{ ...CARD_SURFACE_SX, width: '100%', boxSizing: 'border-box', p: 3, textAlign: 'center', ...sx }}
    >
      <LockOutlinedIcon aria-hidden="true" sx={{ fontSize: 28, color: MUTED_TEXT_COLOR, mb: 1 }} />
      <Typography sx={{ color: '#e4e4e7', fontWeight: 600 }}>Нет доступа к отчётам iiko</Typography>
      <Typography sx={{ mt: 0.5, fontSize: '14px', color: MUTED_TEXT_COLOR }}>
        У вашей учётной записи iiko нет прав на просмотр отчётов. Обратитесь к руководству заведения — права
        выдаются в iikoOffice.
      </Typography>
    </Box>
  );
}
